import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-roleplay-profile',
    templateUrl: './roleplay-profile.component.html',
    styleUrl: './roleplay-profile.component.scss',
    standalone: false
})
export class RoleplayProfileComponent {

  constructor(public Router: Router){}

  createNewScenario() {
    this.Router.navigate(['/app-roleplay-step1', { mode: 'roleplay' }], { skipLocationChange: true });
  }

  roleplayChat() {
    this.Router.navigate(['/app-roleplay-profile', { mode: 'roleplay' }], { skipLocationChange: true });
  }
}
